import { render, staticRenderFns } from "./CreateStudentPage.vue?vue&type=template&id=8b040a38&"
import script from "./CreateStudentPage.vue?vue&type=script&lang=js&"
export * from "./CreateStudentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports